import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { LocalStorage } from 'ngx-store';
import { User, Url } from '../../../model/users.model';
import { ComponentsSettingsService } from 'src/app/services/components_settings.service';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserMenuComponent implements OnInit {

  @LocalStorage() user: User;
  @LocalStorage() url: Url;

  admin: any;
  public folderPath: string;

  constructor( private svc_components : ComponentsSettingsService) { }

  ngOnInit() {
    this.admin = this.user;
    this.folderPath = this.url.fileStorage + '/users/';
  }

  public formatDate(inDate: string) {
    let formatedDate: Date;
    formatedDate = new Date(inDate.replace(/-/g, "/"));
    return formatedDate;
  }

  isEnabled(name){
    let is_enabled = false;
    is_enabled = this.svc_components.isComponentEnabled(name);
    return is_enabled
  }
}
